export { AnnotationStrategy } from "./AnnotationStrategy";
export type { AnnotationStrategyProps } from "./AnnotationStrategy";
export { BoxAnnotationStrategy } from "./BoxAnnotationStrategy";
export { PointAnnotationStrategy } from "./PointAnnotationStrategy";
